// La agencia tal y como la pinta la app: la tarjeta de presentación de la
// ficha del Explorador (heroHtml, la cabecera de «Agencia › Resumen» en la
// consola del dueño) y la ficha pública entera (sheetHtml, «Ver agencia»).
// El HTML lo hacen las funciones de la app (agency-profile.js), que escapan
// todo lo que viene del documento.

import { useEffect, useMemo, useRef } from 'react';
import { AgencyCard, AgencyProfile, ensureAppFont } from '../../lib/agencyApp';

function profileOf(agency, creators) {
  if (!agency) return null;
  return AgencyProfile.fromAgency(agency, Number.isFinite(creators) ? { creators } : {});
}

// Aviso de la consola cuando el Explorador aún no la enseña.
export function visibilityNote(prof) {
  if (!prof) return '';
  if (prof.visibility === 'plan') return 'Su plan no incluye aparecer en el Explorador de Agencias: así la verían los creadores si lo incluyera.';
  if (prof.visibility === 'validation') return 'Aún no sale en el Explorador: falta validarla. Así la verán los creadores cuando se valide.';
  return '';
}

export function AgencyHero({ agency, creators, actionsHtml = '' }) {
  useEffect(() => { ensureAppFont(); }, []);
  const html = useMemo(() => {
    const prof = profileOf(agency, creators);
    if (!prof) return '';
    const a = prof.agency;
    return `<div class="agx-pg is-tier-${AgencyCard.tierOf(a)}">${AgencyProfile.heroHtml(a, prof, false, { actions: actionsHtml, emptyContact: '' })}</div>`;
  }, [agency, creators, actionsHtml]);
  if (!html) return null;
  return <div className="bo-agx" dangerouslySetInnerHTML={{ __html: html }} />;
}

export function AgencySheet({ agency, creators }) {
  const ref = useRef(null);
  useEffect(() => { ensureAppFont(); }, []);
  const html = useMemo(() => {
    const prof = profileOf(agency, creators);
    if (!prof) return '';
    return AgencyProfile.sheetHtml(prof.agency, prof, { preview: true });
  }, [agency, creators]);
  useEffect(() => {
    // Vídeos de «Conoce», carrusel… (lo de la cabecera va apagado en el CSS).
    if (ref.current && html) AgencyProfile.wire(ref.current, {});
  }, [html]);
  if (!html) return null;
  return <div ref={ref} className="bo-agx" dangerouslySetInnerHTML={{ __html: html }} />;
}

export function useAgencyProfile(agency, creators) {
  return useMemo(() => profileOf(agency, creators), [agency, creators]);
}
